import { TareaBBDD } from "@/store/TareasStore";
import { AxiosResponse, AxiosStatic } from "axios";

class TareaService {
  axios;
  baseUrl;
  baseUrlAux;


  constructor(axios: AxiosStatic, apiUrl: string) {
    this.axios = axios;
    this.baseUrl = `${apiUrl}Tarea`;
    this.baseUrlAux = `${apiUrl}`;
  }

  getAll() {
    return this.axios.get(`${this.baseUrl}`);
  }

  getByIdProyecto (id: number): Promise<AxiosResponse<TareaBBDD[]>> {
    return this.axios.get(`${this.baseUrlAux}/TareaByIdProyecto?id=${id}`)
  }

  getPendientes (idUsuario: string): Promise<AxiosResponse<TareaBBDD[]>> {
    return this.axios.get(`${this.baseUrlAux}/AllTareasPendientes?id=${idUsuario}`)
  }

  update(data: TareaBBDD): Promise<AxiosResponse<TareaBBDD>> {
    return this.axios.put(`${this.baseUrl}/?id=${data.Id}`, JSON.stringify(data));
  }

  add(data: TareaBBDD): Promise<AxiosResponse<TareaBBDD>> {
    return this.axios.post(`${this.baseUrl}`, data);
  }

  delete (id: number) {
    return this.axios.delete(`${this.baseUrl}/?id=${id}&deleteRefs=0`) // De momento las referecias no se eliminan
  }
}

export default TareaService;
